import React from 'react';
import styled from 'styled-components';
import { AlertHeader, IconTypes, ModalContent, ModalHeader, ModalLayout, ModalProps, ModalText } from 'components';
import { theme, toRem } from 'design';

interface IErrorModalProps extends ModalProps {
  className?: string;
  title?: string;
  icon?: IconTypes;
  message: string | React.ReactNode;
}

const ErrorHeader = styled(ModalHeader)`
  padding-bottom: ${toRem(10)};
`;

export const ErrorModal: React.FC<IErrorModalProps> = ({ isActive, className = '', title, icon = 'Caution', message, onClose }) => (
  <ModalLayout isActive={isActive} className={`error-modal ${className}`} maxWidth={540} onClose={onClose}>
    <ErrorHeader>
      <AlertHeader icon={icon} iconFill={theme.color.warning.medium} title={title ?? 'Sorry, there was an error!'} />
    </ErrorHeader>
    <ModalContent>{typeof message === 'string' ? <ModalText>{message}</ModalText> : message}</ModalContent>
  </ModalLayout>
);
